export default "__VITE_ASSET__BEXForve__"